import { Component, Input, OnInit } from '@angular/core';
import { OrderDto, PlayerDto, TacticDto, TacticPlayerDto, SubstitutionConditionDto, SubstitutionDto, TacticChangeDto, StandardRoleDto, PlayerSettingsDto, SidePosition } from '../../models';
import { OrderService,  PlayerService, NotificationService, ConfigurationService } from '../../services';
import { CONSTANTS } from '../../constants';
import { Options } from '@angular-slider/ngx-slider';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangeStandardRoleOrderModal, CopyTacticModal, DeleteConfirmationModal, EditSubstitutionModal, EditTacticChangeModal, OrderConfirmationModal, PlayerModal, PlayerSettingsModal, PlayerSkillsModal, PlayMakerModal } from '../../components/modals';
import { BehaviorSubject } from 'rxjs';
import { TeamCardsDto } from 'app/models/dtos/team-cards.dto';
import { FixtureFullDto } from 'app/models/dtos/fixture-full.dto';


@Component({
    selector: 'order-page',
    templateUrl: './order.component.html',
    styleUrls: ['./order.component.scss'],
})
export class OrderComponent implements OnInit {
    @Input() order: OrderDto;

    @Input() teamId: number;

    @Input() teamFormUrl: string;

    @Input() teamCards: TeamCardsDto;

    @Input() players: PlayerDto[];

    @Input() isNationalTeam: boolean;

    @Input() opponentPlayers: PlayerDto[];;

    @Input() nextFixture: FixtureFullDto;

    @Input() canSetupPrice: boolean = false;

    isInitialized: boolean = false;

    currentTactic: TacticDto;
    
    const;

    playersDictionary: PlayerDto[];
    

    allTactics: any[];

    sides: number[];

    pitchPositions: string[];

    substitutionConditions: string[];

    teamSettingsSliderOptions: Options = {
        floor: 10,
        ceil: 90,
        minRange: 5,
        noSwitching: true,
        translate: (value: number): string => {
            return '';
          }
    }

    mentalitySettingsSliderOptions: Options = {
        floor: 1,
        ceil: 99,
    }

    isCollapsed: boolean = true;

    isTacticShown: boolean = true;
    isSubstitutionShown: boolean = false;
    isStrategyShown: boolean = false;
    isRolesShown: boolean = false;

    isCaptainsShown: boolean = true;
    isPenaltiersShown: boolean = false;
    isFreeKickersShown: boolean = false;
    isCornerKickersShown: boolean = false;

    isSaving: boolean = false;

    standardRolePositions: number[];

    selectedPlayerId: number;

    orderPlayers: PlayerDto[];
    reservePlayers: PlayerDto[];
    notInListPlayers: PlayerDto[];

    pitchRefresh: BehaviorSubject<boolean>;

    useRealPlayerSkills: boolean = false;

    teamWork: number = null;

    private orderErrorMessage: string;

    constructor(
        private orderService: OrderService,
        private playerService: PlayerService,
        private modalService: NgbModal,
        private notificationService: NotificationService,
        private configurationService: ConfigurationService) {
            this.const = CONSTANTS;
    }

    ngOnInit() { 
        this.pitchRefresh = new BehaviorSubject<boolean>(true);
        this.initStaticData();
        this.init();
    }

    isPositionTaken(pos: number, side: number): boolean {

        let player = this.getTacticPlayerByPosition(pos, side);

        return player !== undefined && player !== null;
    }

    getPitchPlayerName(pos: number, side: number): string {
        let tacticPlayer =  this.getTacticPlayerByPosition(pos, side);

        if (!tacticPlayer) {
            return null;
        }

        let player = this.getPlayerById(tacticPlayer.playerId);

        if (!player) {
            return null;
        }

        return this.getPlayerName(player);
    }

    getSubstitutionPlayerName(playerId: number): string {
        if (!playerId) return null;
        
        let player = this.getPlayerById(playerId);

        if (!player) {
            return null;
        }


        return this.getPlayerName(player);
    }

    getSubstitutionPlayerAge(playerId: number): number {
        if (!playerId) return null;

        let player = this.getPlayerById(playerId);

        if (!player) {
            return null;
        }


        return player.age;
    }

    getSubstitutionPlayerLeadership(playerId: number): number {
        if (!playerId) return null;
        
        let player = this.getPlayerById(playerId);

        if (!player) {
            return null;
        }


        return player.skills.leadership;
    }

    getSubstitutionPlayerFreeKick(playerId: number): number {
        if (!playerId) return null;
        
        let player = this.getPlayerById(playerId);

        if (!player) {
            return null;
        }


        return player.skills.freeKick;
    }

    getSubstitutionPlayerCornerKick(playerId: number): number {
        if (!playerId) return null;
        
        let player = this.getPlayerById(playerId);

        if (!player) {
            return null;
        }


        return player.skills.cornerKick;
    }

    getSubstitutionPlayerPowerShoot(playerId: number): number {
        if (!playerId) return null;
        
        let player = this.getPlayerById(playerId);

        if (!player) {
            return null;
        }


        return player.skills.powerShoot;
    }

    getSubstitutionPlayerAccuracyShoot(playerId: number): number {
        if (!playerId) return null;
        
        let player = this.getPlayerById(playerId);

        if (!player) {
            return null;
        }


        return player.skills.accuracyShoot;
    }

    getSubstitutionPlayerPower(playerId: number): number {
        if (!playerId) return null;
        
        let player = this.getPlayerById(playerId);

        if (!player) {
            return null;
        }


        return player.power;
    }

    getPlayerName(player: PlayerDto): string {
        let result = (player.name ? player.name[0] + ". " : "" )+ player.surname;

        return result.trim();
    }

    getPlayMakerName() {
        let playMaker = this.getPlayerById(this.currentTactic.playMaker);

        if (!playMaker)
            return "Нет";
        
       let result = (playMaker.name ? playMaker.name[0] + ". " : "" )+ playMaker.surname;

        return result.trim();
    }

    resetPlayMaker() {
        this.currentTactic.playMaker = 0;
    }

    openPlayMakerModal() {
        const modalRef = this.modalService.open(PlayMakerModal);

        modalRef.componentInstance.players= this.orderPlayers.concat(this.reservePlayers).filter(item => !item.isGK);
        modalRef.componentInstance.selectedPlayer = this.getPlayerById(this.currentTactic.playMaker);

        modalRef.result.then((result) => {
            if (result) {
                this.currentTactic.playMaker = result.id;
            }
        }, (reason)=> {});
    }

    openCopyTacticModal() {
        const modalRef = this.modalService.open(CopyTacticModal);
        modalRef.componentInstance.currentTactic = this.currentTactic.number;


        modalRef.result.then((result) => {
            if (result) {
                if (result.destination !== this.currentTactic.number) {
                    this.copyTactic(
                        result.destination,
                        result.isCopyPositions,
                        result.isCopySettings,
                        result.isCopyPlayerSettings);
                }
                
            }
        }, (reason)=> {});
    }

    changeCornerKick(val: number) {
        this.currentTactic.cornerKick = val;
    }

    toggleShortPass() {
        this.currentTactic.shortPass = !this.currentTactic.shortPass;
    }

    toggleMiddlePass() {
        this.currentTactic.middlePass = !this.currentTactic.middlePass;
    }

    toggleLongPass() {
        this.currentTactic.longPass = !this.currentTactic.longPass;
    }

    changeTough(val: number) {
        this.currentTactic.tough = val;
    }

    changeOffsideTrap(val: number) {
        this.currentTactic.offsideTrap = val;
    }

    changeWasteTime(val: number) {
        this.currentTactic.wasteTime = val;
    }

    changeFreeKick(val: number) {
        this.currentTactic.freeKick = val;
    }

    togglePressingOwnHalf() {
        this.currentTactic.pressingOwnHalf = !this.currentTactic.pressingOwnHalf;
    }

    togglePressingCenter() {
        this.currentTactic.pressingCenter = !this.currentTactic.pressingCenter;
    }

    togglePressingOpponentHalf() {
        this.currentTactic.pressingOpponentHalf = !this.currentTactic.pressingOpponentHalf;
    }

    getRightFlankAttackLabel() {
        return 100 - this.currentTactic.rightFlank;
    }

    getCenterAttackLabel() {
        return 100 - this.getRightFlankAttackLabel() - this.currentTactic.leftFlank;
    }

    displayTactic() {
        this.isTacticShown = true;
        this.isSubstitutionShown = false;
        this.isStrategyShown = false;
        this.isRolesShown = false;
    }

    displaySubstitution() {
        this.isTacticShown = false;
        this.isSubstitutionShown = true;
        this.isStrategyShown = false;
        this.isRolesShown = false;
    }

    displayStrategy() {
        this.isTacticShown = false;
        this.isSubstitutionShown = false;
        this.isStrategyShown = true;
        this.isRolesShown = false;
    }

    displayRoles() {
        this.isTacticShown = false;
        this.isSubstitutionShown = false;
        this.isStrategyShown = false;
        this.isRolesShown = true;
    }

    getPitchPositionLabel(index: number) {
        if (!this.pitchPositions)
            return null;
        
        if (!index)
            return "та же";

        return this.pitchPositions[index];
    }

    getSubstitutionConditionLablel(val: SubstitutionConditionDto): string {
        if (!val)
            return null;

        return this.substitutionConditions[val.condition] + " " + val.value;
    }

    deleteSubstitution(index: number) {
        const modalRef = this.modalService.open(DeleteConfirmationModal);

        modalRef.componentInstance.title= "Удаление замены";

        modalRef.result.then((result) => {
            if (result) {
                this.order.substitutions.splice(index, 1);
            }
        }, (reason) => { });
    }

    editSubstitution(index: number) {
        const modalRef = this.modalService.open(EditSubstitutionModal);

        let dto = new SubstitutionDto();
        
        let substitution = this.order.substitutions[index];

        this.cloneSubstitution(substitution, dto);

        modalRef.componentInstance.substitution = dto;
        modalRef.componentInstance.squad = this.orderPlayers;
        modalRef.componentInstance.reserve  = this.reservePlayers;
        modalRef.componentInstance.currectTactic = this.currentTactic;

        modalRef.result.then((result) => {
            if (result) {
                this.order.substitutions[index] = result;
            }
        }, (reason) => { });
    }

    newSubstitution() {
        if (this.order.substitutions && this.order.substitutions.length === 20)
            return;

        const modalRef = this.modalService.open(EditSubstitutionModal);

        let dto = new SubstitutionDto();

        modalRef.componentInstance.substitution = dto;
        modalRef.componentInstance.squad = this.orderPlayers;
        modalRef.componentInstance.reserve  = this.reservePlayers;
        modalRef.componentInstance.currectTactic = this.currentTactic;

        modalRef.result.then((result) => {
            if (result) {
                this.order.substitutions.push(result);
            }
        }, (reason) => { });
    }

    deleteTacticChange(index: number) {
        const modalRef = this.modalService.open(DeleteConfirmationModal);

        modalRef.componentInstance.title= "Удаление смены тактики";

        modalRef.result.then((result) => {
            if (result) {
                this.order.tacticChanges.splice(index, 1);
            }
        }, (error) => { });
    }

    editTacticChange(index: number) {
        const modalRef = this.modalService.open(EditTacticChangeModal);

        let dto = new TacticChangeDto();
        
        let change = this.order.tacticChanges[index];

        this.cloneTacticChange(change, dto);

        modalRef.componentInstance.change = dto;

        modalRef.result.then((result) => {
            if (result) {
                this.order.tacticChanges[index] = result;
            }
        }, (reason) => { });
    }

    newTacticChange() {
        if (this.order.tacticChanges && this.order.tacticChanges.length === 20)
            return;

        const modalRef = this.modalService.open(EditTacticChangeModal);

        let dto = new TacticChangeDto();
        dto.isChangePosition = true;
        dto.isChangeSettings = true;

        modalRef.componentInstance.change = dto;

        modalRef.result.then((result) => {
            if (result) {
                this.order.tacticChanges.push(result);
            }
        }, (reason) => { });
    }

    getStandardRoleByRoleAndPos(role: number, pos: number) {
        let arr: StandardRoleDto[] = [];
        
        switch (role) {
            case CONSTANTS.standardRoles.captains:
                arr = this.order.captains;
                break;
            case CONSTANTS.standardRoles.freeKickers:
                arr = this.order.freeKickers;
                break;
            case CONSTANTS.standardRoles.cornerKickers:
                arr = this.order.cornerKickers;
                break;
            case CONSTANTS.standardRoles.penaltiers:
                arr = this.order.penaltiers;
                break;
        }

        let playerRole = arr.find(item => item.order === pos);

        if (!playerRole) {
            return null;
        }

        return this.getPlayerById(playerRole.playerId);
    }

    moveStandardRoleUp(role: number, index: number) {
        let arr: StandardRoleDto[] = [];
        
        switch (role) {
            case CONSTANTS.standardRoles.captains:
                arr = this.order.captains;
                break;
            case CONSTANTS.standardRoles.freeKickers:
                arr = this.order.freeKickers;
                break;
            case CONSTANTS.standardRoles.cornerKickers:
                arr = this.order.cornerKickers;
                break;
            case CONSTANTS.standardRoles.penaltiers:
                arr = this.order.penaltiers;
                break;
        }

        if (index > 0) {
            let temp = arr[index].playerId;
            arr[index].playerId = arr[index - 1].playerId;
            arr[index - 1].playerId = temp;
        }
    }

    moveStandardRoleDown(role: number, index: number) {
        let arr: StandardRoleDto[] = [];
        
        switch (role) {
            case CONSTANTS.standardRoles.captains:
                arr = this.order.captains;
                break;
            case CONSTANTS.standardRoles.freeKickers:
                arr = this.order.freeKickers;
                break;
            case CONSTANTS.standardRoles.cornerKickers:
                arr = this.order.cornerKickers;
                break;
            case CONSTANTS.standardRoles.penaltiers:
                arr = this.order.penaltiers;
                break;
        }

        if (index < arr.length - 1) {
            let temp = arr[index].playerId;
            arr[index].playerId = arr[index + 1].playerId;
            arr[index + 1].playerId = temp;
        }
    }
    
    onChangeCaptainRoleOrder(order: number, playerId: number) {
        this.onChangeStandardRoleOrder(order, playerId, this.order.captains);
    }

    onChangePenaltiesRoleOrder(order: number, playerId: number) {
        this.onChangeStandardRoleOrder(order, playerId, this.order.penaltiers);
    }

    onChangeFreekickRoleOrder(order: number, playerId: number) {
        this.onChangeStandardRoleOrder(order, playerId, this.order.freeKickers);
    }

    onChangeCornerRoleOrder(order: number, playerId: number) {
        this.onChangeStandardRoleOrder(order, playerId, this.order.cornerKickers);
    }


    onChangeStandardRoleOrder(order: number, playerId: number, roles: StandardRoleDto[]) {
        const modalRef = this.modalService.open(ChangeStandardRoleOrderModal);
        
                modalRef.componentInstance.player = this.playersDictionary[playerId];
                modalRef.componentInstance.currentOrder = order;
                modalRef.componentInstance.maxOrder = this.players.length;
        
                modalRef.result.then((result) => {
                    if (result) {

                        if (result !== order) {
                            var newStandardRole = roles.find(c => c.order == result);
                            var oldStandardRole = roles.find(c => c.order == order);

                            if (newStandardRole) {
                                let pl = newStandardRole.playerId;
                                newStandardRole.playerId = oldStandardRole.playerId;
                                oldStandardRole.playerId = pl;
                            } else {
                                oldStandardRole.order = result;
                            }
                        }
                    }
                });
    }

    showCaptains() {
        this.isCaptainsShown = true;
        this.isPenaltiersShown = false;
        this.isFreeKickersShown = false;
        this.isCornerKickersShown = false;
    }

    showPenaltiers() {
        this.isCaptainsShown = false;
        this.isPenaltiersShown = true;
        this.isFreeKickersShown = false;
        this.isCornerKickersShown = false;
    }

    showFreeKickers() {
        this.isCaptainsShown = false;
        this.isPenaltiersShown = false;
        this.isFreeKickersShown = true;
        this.isCornerKickersShown = false;
    }

    showCornerKickers() {
        this.isCaptainsShown = false;
        this.isPenaltiersShown = false;
        this.isFreeKickersShown = false;
        this.isCornerKickersShown = true;

    }

    onSelectPlayer(playerId: number) {
        if (!playerId) {
            this.selectedPlayerId = null;
            return;
        }

        if (playerId === this.selectedPlayerId) {
            this.selectedPlayerId = null;
            return;
        }
            
        this.ensurePlayerSettings(playerId);

        this.selectedPlayerId = playerId;
    }

    onMovePlayer(direction: number) {
        let currTacticPlayer = this.currentTactic.squad.find(el => el.playerId == this.selectedPlayerId);
        let position = currTacticPlayer.position;
        let side = currTacticPlayer.side;

        if (direction === CONSTANTS.playerMoveDirections.left)  {
            side --;

            if (side < CONSTANTS.tacticSides.l) {
                side = CONSTANTS.tacticSides.l;
            }
        }

        if (direction === CONSTANTS.playerMoveDirections.right)  {
            side++;

            if (side > CONSTANTS.tacticSides.r) {
                side = CONSTANTS.tacticSides.r;
            }
        }

        if (direction === CONSTANTS.playerMoveDirections.up)  {
            position ++;

            if (position > CONSTANTS.tacticPositions.fw) {
                side = CONSTANTS.tacticPositions.fw;
            }
        }

        if (direction === CONSTANTS.playerMoveDirections.down)  {
            position --;

            if (position < CONSTANTS.tacticPositions.sw) {
                side = CONSTANTS.tacticPositions.sw;
            }
        }
        
        this.moveSelectedPlayerToNewPosition(position, side);
    }

    changePlayer(pl: PlayerDto) {
        let plId = pl.id;

        this.ensurePlayerSettings(plId);

        let tempPlId = -1;

        let selectedPlId = this.selectedPlayerId;

        if (this.isSquadPlayer(selectedPlId)) {
            this.swapSquadPlayer(tempPlId, selectedPlId);

            if (this.isSquadPlayer(plId)) {
                this.swapSquadPlayer(selectedPlId, plId);
            } else if (this.isReservePlayer(plId)) {
                this.swapReservePlayer(selectedPlId, plId);
            } else {
                this.swapNotInListPlayer(selectedPlId, plId);
            }

            this.swapSquadPlayer(plId, tempPlId);
        } 
        else if (this.isReservePlayer(selectedPlId))  {
            this.swapReservePlayer(tempPlId, selectedPlId);

            if (this.isSquadPlayer(plId)) {
                this.swapSquadPlayer(selectedPlId, plId);
            } else if (this.isReservePlayer(plId)) {
                this.swapReservePlayer(selectedPlId, plId)
            } else {
                this.swapNotInListPlayer(selectedPlId, plId);
            }

            this.swapReservePlayer(plId, tempPlId);
        } else {
            this.swapNotInListPlayer(tempPlId, selectedPlId);

            if (this.isSquadPlayer(plId)) {
                this.swapSquadPlayer(selectedPlId, plId);
            } else if (this.isReservePlayer(plId)) {
                this.swapReservePlayer(selectedPlId, plId);
            } else {
                this.swapNotInListPlayer(selectedPlId, plId)
            }

            this.swapNotInListPlayer(plId, tempPlId);
        }

        this.selectedPlayerId = plId;
        this.buildPlayersLists();
        this.getTeamWork();
        this.pitchRefresh.next(true);
    }

    resetPlayerSelection() {
        this.selectedPlayerId = null;
    }

    getPlayerById(plId: number) : PlayerDto {
        if (!this.playersDictionary)
            return null;

        return this.playersDictionary[plId];
    }

    onChangePlayerSettings(ev: Event) {
        ev.stopPropagation();

        const modalRef = this.modalService.open(PlayerSettingsModal);

        let playerSettings = this.currentTactic.playersSettings.find(item => item.playerId == this.selectedPlayerId);

        modalRef.componentInstance.playerSettings = playerSettings ? playerSettings : this.getDefaultPlayerSettings();
        modalRef.componentInstance.playerName = this.getSubstitutionPlayerName(this.selectedPlayerId);
        modalRef.componentInstance.isGk = false;
        modalRef.componentInstance.opponent = this.opponentPlayers;

        modalRef.result.then((result) => {
            if (result) {
                
            }
        }, (reason) => { });
    }

    getPlayerPositionsLabel(pl : number) : string {

        return this.playerService.formatPlayerPosition(this.getPlayerById(pl));
    }

    onShowPlayerSkills(ev: Event, plId: number) {
        ev.stopPropagation();
        
        const modalRef = this.modalService.open(PlayerSkillsModal);

        modalRef.componentInstance.player = this.getPlayerById(plId);

        modalRef.result.then((result) => {}, (reason) => { });

    }

    onChangePlayer(ev: Event) {
        ev.stopPropagation();

        const modalRef = this.modalService.open(PlayerModal);
        
        modalRef.componentInstance.squadPlayers= this.playerService.sortTacticPlayersByPosition(this.currentTactic.squad, this.orderPlayers);
        //modalRef.componentInstance.squadPlayers = this.orderPlayers;
        modalRef.componentInstance.substitutionPlayers = this.playerService.sortPlayersByPosition(this.reservePlayers);
        modalRef.componentInstance.resevePlayers = this.playerService.sortPlayersByPosition(this.notInListPlayers);

        modalRef.componentInstance.selectedPlayer = this.playersDictionary[this.selectedPlayerId];

        modalRef.result.then((result) => {
            if (result) {
                this.changePlayer(result);
            }
        }, (reason) => {});
    }

    isPlayerBanned(playerId: number): boolean {
        if (!this.teamCards)
            return false;

        return this.teamCards.redCards.find(c=>c.playerId === playerId) !== undefined;
    }

    isPlayerInjured(playerId: number): boolean {
        let pl = this.playersDictionary[playerId];

        return pl.injuryLength > 0;
    }

    isPlayerYellowCard(playerId: number): boolean {
        if (!this.teamCards)
            return false;

        return this.teamCards.yellowCards.includes(playerId);
    }

    onSave() {
        if (this.isSaving) {
            return;
        }

        let substValid = this.areAllSubstitutionsValid();
        
        if (substValid) {
            this.save();
        } else {
            const modalRef = this.modalService.open(OrderConfirmationModal);

            modalRef.componentInstance.message = 'Некоторые замены неактуальны. Удалить их и сохранить состав?';

            modalRef.result.then((result) => {
                if (result) {
                    this.cleanSubstitutions();
                    this.save();
                } else {
                    this.notificationService.showError('Состав не был сохранен. Исправьте условия замен перед сохранением.')
                }
            }, (reason) => { });
        }
       
    }

    private save() {
        if (!this.isOrderValid()) {
            const modalRef = this.modalService.open(OrderConfirmationModal);

            modalRef.componentInstance.message= this.orderErrorMessage + ' Все равно сохранить?';

            modalRef.result.then((result) => {
                if (result) {
                    this.saveOrder();
                }
            }, (reason) => { });
        } else {
            this.saveOrder();
        }
    }

    getPlayerPhotoUrl(plId: number) {
        let pl = this.playersDictionary[plId];

        return pl.photoUrl;
    }

    getSelectedPlayer(): PlayerDto {
        return this.playersDictionary[this.selectedPlayerId];
    }

    getSelectedPlayerSettings(): PlayerSettingsDto {
        //TODO uncomment this for support old generator
        //return this.order.tactics[0].playersSettings.find(item => item.playerId == this.selectedPlayerId);
        
        return this.currentTactic.playersSettings.find(item => item.playerId == this.selectedPlayerId);
    }

    isSelectedPlayerGK(): boolean {
        let pl = this.playersDictionary[this.selectedPlayerId];

        return pl.isGK;
    }

    changeDisplaySkillsMode(mode: boolean) {
        this.useRealPlayerSkills = mode;
    }

    gotoClassicView() {
        window.location.href = this.isNationalTeam ? this.configurationService.getFintFMUrl() +  "/modules.php?name=sostavnt_new" : this.configurationService.getFintFMUrl() + "/modules.php?name=sostav_new";
    }

    isSubstitutionInvalid(item: SubstitutionDto): boolean {
        let outPlayer = this.orderPlayers.find(x => x.id == item.playerOut);
        
        let inPlayer = this.reservePlayers.find(x => x.id == item.playerIn);
        
        return (outPlayer === undefined || inPlayer === undefined);
    }

    onReset() {
        if (this.isSaving) {
            return;
        }

        const modalRef = this.modalService.open(OrderConfirmationModal);

        modalRef.componentInstance.message = 'Вы уверены, что хотите сбросить все установки?';
        modalRef.componentInstance.header = 'Сброс установок';

        modalRef.result.then((result) => {
            if (result) {
                this.resetOrder();
            }
        }, (reason) => { });
    }

    private areAllSubstitutionsValid(): boolean {
        let result = true;

        this.order.substitutions.forEach(item => {
            if (this.isSubstitutionInvalid(item)) {
                result = false;
            }
        })

        return result;
    }

    private getTacticPlayerByPosition(pos: number, side: number): TacticPlayerDto {
        var result = this.currentTactic.squad.find(element => element.position === pos && element.side === side);

        return result;
    }

    private init() {
        this.selectTactic(1);

        this.playersDictionary = [];

        this.players.forEach(element => {
            this.playersDictionary[element.id] = element;
        });

        this.buildPlayersLists();

        this.getTeamWork();

        this.isInitialized = true;
    }

    private selectTactic(number: number) {
        this.currentTactic = this.order.tactics.find(item => item.number == number);
        
    }

    private initStaticData() {
        this.sides = [];
        this.sides.push(CONSTANTS.tacticSides.l);
        this.sides.push(CONSTANTS.tacticSides.lc);
        this.sides.push(CONSTANTS.tacticSides.c);
        this.sides.push(CONSTANTS.tacticSides.rc);
        this.sides.push(CONSTANTS.tacticSides.r);

        this.allTactics = [];
        this.allTactics.push({ index: 1, name: 'Стартовый состав'});
        this.allTactics.push({ index: 2, name: 'Тактика 2'});
        this.allTactics.push({ index: 3, name: 'Тактика 3'});
        this.allTactics.push({ index: 4, name: 'Тактика 4'});
        this.allTactics.push({ index: 5, name: 'Тактика 5'});
        this.allTactics.push({ index: 6, name: 'Тактика 6'});
        this.allTactics.push({ index: 7, name: 'Тактика 7'});

        this.pitchPositions = [];
        this.pitchPositions[CONSTANTS.pitchPositions.gk] = CONSTANTS.pitchPositionNames.gk;
        this.pitchPositions[CONSTANTS.pitchPositions.sw] = CONSTANTS.pitchPositionNames.sw;
        this.pitchPositions[CONSTANTS.pitchPositions.ldf] = CONSTANTS.pitchPositionNames.ldf;
        this.pitchPositions[CONSTANTS.pitchPositions.cdf] = CONSTANTS.pitchPositionNames.cdf;
        this.pitchPositions[CONSTANTS.pitchPositions.rdf] = CONSTANTS.pitchPositionNames.rdf;
        this.pitchPositions[CONSTANTS.pitchPositions.ldm] = CONSTANTS.pitchPositionNames.ldm;
        this.pitchPositions[CONSTANTS.pitchPositions.cdm] = CONSTANTS.pitchPositionNames.cdm;
        this.pitchPositions[CONSTANTS.pitchPositions.rdm] = CONSTANTS.pitchPositionNames.rdm;
        this.pitchPositions[CONSTANTS.pitchPositions.lmf] = CONSTANTS.pitchPositionNames.lmf;
        this.pitchPositions[CONSTANTS.pitchPositions.cmf] = CONSTANTS.pitchPositionNames.cmf;
        this.pitchPositions[CONSTANTS.pitchPositions.rmf] = CONSTANTS.pitchPositionNames.rmf;
        this.pitchPositions[CONSTANTS.pitchPositions.lam] = CONSTANTS.pitchPositionNames.lam;
        this.pitchPositions[CONSTANTS.pitchPositions.cam] = CONSTANTS.pitchPositionNames.cam;
        this.pitchPositions[CONSTANTS.pitchPositions.ram] = CONSTANTS.pitchPositionNames.ram;
        this.pitchPositions[CONSTANTS.pitchPositions.lfw] = CONSTANTS.pitchPositionNames.lfw;
        this.pitchPositions[CONSTANTS.pitchPositions.cfw] = CONSTANTS.pitchPositionNames.cfw;
        this.pitchPositions[CONSTANTS.pitchPositions.rfw] = CONSTANTS.pitchPositionNames.rfw;

        this.substitutionConditions = [];
        this.substitutionConditions[CONSTANTS.substitutionConditions.less] = CONSTANTS.substitutionConditionNames.less;
        this.substitutionConditions[CONSTANTS.substitutionConditions.equal] = CONSTANTS.substitutionConditionNames.equal;
        this.substitutionConditions[CONSTANTS.substitutionConditions.more] = CONSTANTS.substitutionConditionNames.more;

    }

    private getOrderPlayers(): PlayerDto[] {
        let result: PlayerDto[] = [];

        let playerIds: number[] = [];
        
        this.currentTactic.squad.forEach(item => {
            //if (item.position !== CONSTANTS.tacticPositions.gk) {
                playerIds.push(item.playerId);
            //}
        });

        playerIds.forEach(item => {
            result.push(this.playersDictionary[item]);
        });

        return result;

    }

    private cloneSubstitution(src: SubstitutionDto, result: SubstitutionDto) {
        

        result.playerIn = src.playerIn;
        result.playerOut = src.playerOut;
        result.isYellowCard = src.isYellowCard;
        result.position = src.position;

        if (src.minute) {
            result.minute = new SubstitutionConditionDto();
            result.minute.condition = src.minute.condition;
            result.minute.value = src.minute.value;
        }

        if (src.mark) {
            result.mark = new SubstitutionConditionDto();
            result.mark.condition = src.mark.condition;
            result.mark.value = src.mark.value;
        }

        if (src.physic) {
            result.physic = new SubstitutionConditionDto();
            result.physic.condition = src.physic.condition;
            result.physic.value = src.physic.value;
        }

        if (src.score) {
            result.score = new SubstitutionConditionDto();
            result.score.condition = src.score.condition;
            result.score.value = src.score.value;
        }

        return result;
    }

    private cloneTacticChange(src: TacticChangeDto, result: TacticChangeDto) {

        result.tactic = src.tactic;
        result.isChangePosition = src.isChangePosition;
        result.isChangeSettings = src.isChangeSettings;

        if (src.minute) {
            result.minute = new SubstitutionConditionDto();
            result.minute.condition = src.minute.condition;
            result.minute.value = src.minute.value;
        }

        if (src.score) {
            result.score = new SubstitutionConditionDto();
            result.score.condition = src.score.condition;
            result.score.value = src.score.value;
        }

        return result;
    }

    private getReservePlayers() : PlayerDto[] {
        let result: PlayerDto[] = [];

        this.order.reserve.forEach(item => {
            result.push(this.playersDictionary[item]);
        });

        return result;
    }

    private getNotInListPlayers(): PlayerDto[] {
        let result: PlayerDto[] = [];

        this.order.notInListPlayers.forEach(item => {
            result.push(this.playersDictionary[item]);
        });

        return result;
    }

    private buildPlayersLists() {
        this.orderPlayers = this.getOrderPlayers();
        this.reservePlayers = this.getReservePlayers();
        this.notInListPlayers = this.getNotInListPlayers();
    }

    private getDefaultPlayerSettings() : PlayerSettingsDto {
        let result = new PlayerSettingsDto();

        result.attackHelp = CONSTANTS.playerSettings.variant3.sometimes;
        result.cutPass = CONSTANTS.playerSettings.variant3.sometimes;
        result.defenceHelp = CONSTANTS.playerSettings.variant3.sometimes;
        result.dribbling = CONSTANTS.playerSettings.variant3.sometimes;
        result.freeRole = CONSTANTS.playerSettings.variant2.no;
        result.longShots = CONSTANTS.playerSettings.variant3.sometimes;
        result.offside = CONSTANTS.playerSettings.variant3.sometimes;
        result.passType = CONSTANTS.playerSettings.passTypes.team;
        result.standardAtttack = CONSTANTS.playerSettings.variant2.no;
        result.standardDefence = CONSTANTS.playerSettings.variant2.no;
        result.tacticNumber = this.currentTactic.number;
        result.playerId = this.selectedPlayerId;



        return result;
    }


    private moveSelectedPlayerToNewPosition(position: number, side: number) {
       
        let currTacticPlayer = this.currentTactic.squad.find(el => el.playerId == this.selectedPlayerId);
        const prevPosition = currTacticPlayer.position;
        const prevSide = currTacticPlayer.side;

        if (!this.isPositionTaken(position, side)) {
            currTacticPlayer.position = position;
            currTacticPlayer.side =  side;
        } else {
            let player = this.getTacticPlayerByPosition(position, side);

            const newPosition = player.position;
            const newSide = player.side; 

            player.position = prevPosition;
            player.side = prevSide;

            currTacticPlayer.position = newPosition;
            currTacticPlayer.side = newSide;

            this.pitchRefresh.next(true);
        }
    }

    private isSquadPlayer(playerId: number): boolean {
        return this.currentTactic.squad.find(p => p.playerId == playerId) !== undefined ;
    }

    private isReservePlayer(playerId: number): boolean {
        return this.reservePlayers.find(p => p.id == playerId) !== undefined ;
    }

    private swapSquadPlayer(newId: number, oldId: number) {
        this.order.tactics.forEach(t => {
            t.squad.forEach(p => {
                if (p.playerId == oldId) {
                    p.playerId = newId;
                }
            })
        })
    }

    private swapReservePlayer(newId: number, oldId: number) {
        let index = this.order.reserve.indexOf(oldId);

        this.order.reserve[index] = newId;
    }

    private swapNotInListPlayer(newId: number, oldId: number) {
        let index = this.order.notInListPlayers.indexOf(oldId);

        this.order.notInListPlayers[index] = newId;
    }


    private isOrderValid(): boolean {
        let reservePlayers = this.getReservePlayers();
        let squadPlayers = this.getOrderPlayers();

        let players = reservePlayers.concat(squadPlayers);

        this.orderErrorMessage = null;

        for (let i=0; i< players.length; i++) {
            let item = players[i];

            if (this.isPlayerInjured(item.id)) {
                this.orderErrorMessage = 'В заявке находится травмированный игрок.';
                return false;
            }

            if (this.isPlayerBanned(item.id)) {
                this.orderErrorMessage = 'В заявке находится дисквалифицированный игрок.';
                return false;
            }
        }

        return true;
    }

    private saveOrder() {
        this.isSaving = true;

        this.orderService.save(this.order, this.isNationalTeam)
            .subscribe(result => {
                this.isSaving = false;
                
                this.notificationService.showSuccess("Состав успешно сохранен.");
            }, error => {
                this.isSaving = false;
                
                this.notificationService.showError("Ошибка сохранения состава:" + error.error);
            })
    }

    private getTeamWork() {
        if (this.isNationalTeam) {
            this.teamWork = 50;

            return;
        }

        this.teamWork = null;

        let playerIds: number[] = [];

        this.orderPlayers.forEach(item => {
            playerIds.push(item.id);
        });

        this.orderService.getTeamWork(playerIds)
            .subscribe(result=> {
                this.teamWork = result.value;
            })
    }

    private ensurePlayerSettings(plId: number) {
        this.order.tactics.forEach(item => {
            let settings = item.playersSettings.find(i => i.playerId == plId);

            if (!settings) {
                let newSettings = this.buildDefaultPlayerSettings(plId);

                newSettings.tacticNumber = item.number;
                item.playersSettings.push(newSettings);
            }
        })
    }

    private buildDefaultPlayerSettings(plId: number): PlayerSettingsDto {
        let settings = new PlayerSettingsDto();

        settings.attackHelp = CONSTANTS.playerSettings.variant3.rare;
        settings.cutPass = CONSTANTS.playerSettings.variant3.rare;
        settings.defenceHelp = CONSTANTS.playerSettings.variant3.rare;
        settings.dribbling = CONSTANTS.playerSettings.variant3.rare;;
        settings.freeRole = CONSTANTS.playerSettings.variant2.no;
        settings.longShots = CONSTANTS.playerSettings.variant3.rare;
        settings.markPlayerId = 0;
        settings.offside = CONSTANTS.playerSettings.variant3.rare;
        settings.passType = CONSTANTS.playerSettings.passTypes.team;
        settings.playerId = plId;
        settings.standardAtttack = CONSTANTS.playerSettings.variant2.no;
        settings.standardDefence = CONSTANTS.playerSettings.variant2.no;

        return settings;
    }

    private cleanSubstitutions() {
        let subst: SubstitutionDto[] = [];
        if (this.order.substitutions && this.order.substitutions.length > 0) {
            this.order.substitutions.forEach(item => {
                if (!this.isSubstitutionInvalid(item)) {
                    subst.push(item);
                }
            });

            this.order.substitutions = subst;
            this.notificationService.showSuccess('Неактуальные замены удалены.')
        }

        
        /*this.order.substitutions.forEach(item => {
            if (item.playerIn == pl1Id) {
                item.playerIn = pl2Id;
            } else if (item.playerIn == pl2Id){
                item.playerIn = pl1Id;
            }

            if (item.playerOut == pl1Id) {
                item.playerOut = pl2Id;
            } else if (item.playerOut == pl2Id){
                item.playerOut = pl1Id;
            }
        });*/
    }

    private copyTactic(destination: number, copyTactic: boolean, copySettings: boolean, copyPlayerSettings: boolean, notify: boolean = true) {
        let tacticDest = this.order.tactics.find(t => t.number === destination);
        
        if (copyTactic) {
            tacticDest.squad = [];
            this.currentTactic.squad.forEach(item => {
                let pl = new TacticPlayerDto();
                pl.position = item.position;
                pl.side = item.side;
                pl.playerId = item.playerId;

                tacticDest.squad.push(pl);
            });
        }

        if (copySettings) {
            tacticDest.cornerKick = this.currentTactic.cornerKick;
            tacticDest.freeKick = this.currentTactic.freeKick;
            tacticDest.leftFlank = this.currentTactic.leftFlank;
            tacticDest.longPass = this.currentTactic.longPass;
            tacticDest.mentality = this.currentTactic.mentality;
            tacticDest.middlePass = this.currentTactic.middlePass;
            tacticDest.offsideTrap = this.currentTactic.offsideTrap;
            tacticDest.playMaker = this.currentTactic.playMaker;
            tacticDest.pressingCenter = this.currentTactic.pressingCenter;
            tacticDest.pressingOpponentHalf = this.currentTactic.pressingOpponentHalf;
            tacticDest.pressingOwnHalf = this.currentTactic.pressingOwnHalf;
            tacticDest.rightFlank = this.currentTactic.rightFlank;
            tacticDest.shortPass = this.currentTactic.shortPass;
            tacticDest.tough = this.currentTactic.tough;
            tacticDest.wasteTime = this.currentTactic.wasteTime;
        }

        if (copyPlayerSettings) {
            this.currentTactic.playersSettings.forEach(item => {
                let pl = tacticDest.playersSettings.find(pl => pl.playerId == item.playerId);
                if (!pl) {
                    pl = new PlayerSettingsDto();
                    pl.playerId = item.playerId;
                    pl.tacticNumber = tacticDest.number;
                    
                    tacticDest.playersSettings.push(pl);
                }

                pl.attackHelp = item.attackHelp;
                pl.cutPass = item.cutPass;
                pl.defenceHelp = item.defenceHelp;
                pl.dribbling = item.dribbling;
                pl.freeRole = item.freeRole;
                pl.longShots = item.longShots;
                pl.markPlayerId = item.markPlayerId;
                pl.offside = item.offside;
                pl.passType = item.passType;
                pl.standardAtttack = item.standardAtttack;
                pl.standardDefence = item.standardDefence;
            });
        }
        
        if (notify)
            this.notificationService.showSuccess('Настройки тактики скопированы');
    }

    private resetOrder() {
        this.selectedPlayerId = null;
        this.order.substitutions = [];
        this.order.tacticChanges = [];
        
        let mainTactic = new TacticDto();

        mainTactic.cornerKick = 1;
        mainTactic.freeKick = 1;
        mainTactic.leftFlank = 33;
        mainTactic.rightFlank = 100-33;
        mainTactic.longPass = false;
        mainTactic.mentality = 50;
        mainTactic.middlePass = false;
        mainTactic.number = 1;
        mainTactic.offsideTrap = 2;
        mainTactic.playMaker = 0;
        mainTactic.pressingCenter = false;
        mainTactic.playersSettings = this.buildDefaultSettings();
        mainTactic.squad = this.buildDefaultSquad();
        mainTactic.pressingOpponentHalf = false;
        mainTactic.pressingOwnHalf = false;
        mainTactic.shortPass = false;
        mainTactic.tough = 1;
        mainTactic.wasteTime = 1;

        for (let i = 0; i < this.order.tactics.length; i++) {
            if (this.order.tactics[i].number === 1) {
                this.order.tactics[i] = mainTactic;
                break;
            }
        }
        
        this.selectTactic(1);

        for (let i = 2; i<8; i++) {
            this.copyTactic(i, true, true, true, false);
        }

        //build substiontions list
        let playersList: PlayerDto[] = [];

        this.players.forEach(item => {
            if (!mainTactic.squad.find(p => p.playerId == item.id))
                playersList.push(item);
        });

        playersList.sort((a,b) =>  b.power - a.power);

        this.order.reserve = [];

        for (let i=0; i<7; i++) {
            this.order.reserve.push(playersList[0].id);
            playersList.splice(0, 1);
        }

        this.order.notInListPlayers = [];

        playersList.forEach(item => {
            this.order.notInListPlayers.push(item.id);
        });

        this.buildPlayersLists();
    }

    private buildDefaultSettings(): PlayerSettingsDto[] {
        let result: PlayerSettingsDto[] = [];

        this.players.forEach(item => {
            let setting = new PlayerSettingsDto();

            setting.attackHelp = CONSTANTS.playerSettings.variant3.rare;
            setting.cutPass = CONSTANTS.playerSettings.variant3.rare;
            setting.defenceHelp = CONSTANTS.playerSettings.variant3.rare;
            setting.dribbling = CONSTANTS.playerSettings.variant3.rare;
            setting.freeRole = CONSTANTS.playerSettings.variant2.no;
            setting.longShots = CONSTANTS.playerSettings.variant3.rare;
            setting.markPlayerId = 0;
            setting.offside = CONSTANTS.playerSettings.variant3.rare;
            setting.passType = CONSTANTS.playerSettings.passTypes.team;
            setting.playerId = item.id;
            setting.standardAtttack = CONSTANTS.playerSettings.variant2.no;
            setting.standardDefence = CONSTANTS.playerSettings.variant2.no;
            setting.tacticNumber = 1;

            result.push(setting);
        })

        return result;
    }

    private buildDefaultSquad(): TacticPlayerDto[] {
        let result = [];

        result.push(this.buildEmptyTacticPosition(CONSTANTS.tacticPositions.gk, CONSTANTS.tacticSides.c));
        result.push(this.buildEmptyTacticPosition(CONSTANTS.tacticPositions.df, CONSTANTS.tacticSides.l));
        result.push(this.buildEmptyTacticPosition(CONSTANTS.tacticPositions.df, CONSTANTS.tacticSides.lc));
        result.push(this.buildEmptyTacticPosition(CONSTANTS.tacticPositions.df, CONSTANTS.tacticSides.rc));
        result.push(this.buildEmptyTacticPosition(CONSTANTS.tacticPositions.df, CONSTANTS.tacticSides.r));

        result.push(this.buildEmptyTacticPosition(CONSTANTS.tacticPositions.mf, CONSTANTS.tacticSides.l));
        result.push(this.buildEmptyTacticPosition(CONSTANTS.tacticPositions.mf, CONSTANTS.tacticSides.lc));
        result.push(this.buildEmptyTacticPosition(CONSTANTS.tacticPositions.mf, CONSTANTS.tacticSides.rc));
        result.push(this.buildEmptyTacticPosition(CONSTANTS.tacticPositions.mf, CONSTANTS.tacticSides.r));

        result.push(this.buildEmptyTacticPosition(CONSTANTS.tacticPositions.fw, CONSTANTS.tacticSides.lc));
        result.push(this.buildEmptyTacticPosition(CONSTANTS.tacticPositions.fw, CONSTANTS.tacticSides.rc));

        let playersList: PlayerDto[] = [];

        this.players.forEach(item => {
            if ((!item.injuryLength || item.injuryLength ==0) && !this.isPlayerBanned(item.id))
                playersList.push(item);
        })

        result.forEach(item => {
            let pl = this.getBestPlayerForPosition(playersList, item.position, item.side);

            item.playerId = pl.id;

            for( var i = 0; i < playersList.length; i++){ 
                    if ( playersList[i].id == item.playerId) { 
                
                        playersList.splice(i, 1); 

                        break;
                    }
                
                }
        });

        return result;
    }

    private buildEmptyTacticPosition(position: number, side: number):TacticPlayerDto {
        let result = new TacticPlayerDto();
        result.position = position;
        result.side = side;

        return result;
    }

    private getBestPlayerForPosition(playersList: PlayerDto[], position: number, side: number): PlayerDto {
        if (!playersList || playersList.length === 0){
            this.notificationService.showError('Не хватает игроков в команде!');
            return;
        }

        let fines: any[] = [];

        let pos = this.buildSidePosition(position, side);

        playersList.forEach(item => {
            let fine = this.getPlayerFineForPosition(item, pos);
            fines.push({pl: item, fine: fine});
        })
    
        fines.sort((a,b) =>  a.fine - b.fine );

        let minFine = fines[0].fine;

        let minFines: any[] = [];

        fines.forEach(item => {
            if (item.fine == minFine)
                minFines.push(item);
        });

        minFines.sort((a,b) =>  b.pl.power - a.pl.power);

        return minFines[0].pl;
    }

    private getPlayerFineForPosition(player: PlayerDto, sidePosition: SidePosition): number {
        let sidePositions = this.getPlayerSidePositions(player);

        let fines: number[] = [];

        sidePositions.forEach(item => {
            let fine = this.getSidePositionFine(item, sidePosition);

            fines.push(fine);
        });

        let result = fines[0];

        fines.forEach(item => {
            if (result > item)
                result = item;
        });

        return result;
    }

    private getPlayerSidePositions(player: PlayerDto) : SidePosition[] {
        let result = [];

        if (player.isGK)
        {
            result.push(this.buildSidePosition(CONSTANTS.tacticPositions.gk, CONSTANTS.tacticSides.c));

            return result;
        }

        if (player.isSW){
            result.push(this.buildSidePosition(CONSTANTS.tacticPositions.sw, CONSTANTS.tacticSides.c));
        }

        if (player.isDF) {
            if (player.isLeft) {
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.df, CONSTANTS.tacticSides.l));
            }

            if (player.isRight) {
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.df, CONSTANTS.tacticSides.r));
            }

            if (player.isCenter) {
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.df, CONSTANTS.tacticSides.rc));
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.df, CONSTANTS.tacticSides.c));
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.df, CONSTANTS.tacticSides.lc));
            }
        }

        if (player.isDM) {
            if (player.isLeft) {
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.dm, CONSTANTS.tacticSides.l));
            }

            if (player.isRight) {
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.dm, CONSTANTS.tacticSides.r));
            }

            if (player.isCenter) {
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.dm, CONSTANTS.tacticSides.rc));
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.dm, CONSTANTS.tacticSides.c));
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.dm, CONSTANTS.tacticSides.lc));
            }
        }

        if (player.isMF) {
            if (player.isLeft) {
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.mf, CONSTANTS.tacticSides.l));
            }

            if (player.isRight) {
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.mf, CONSTANTS.tacticSides.r));
            }

            if (player.isCenter) {
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.mf, CONSTANTS.tacticSides.rc));
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.mf, CONSTANTS.tacticSides.c));
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.mf, CONSTANTS.tacticSides.lc));
            }
        }

        if (player.isAM) {
            if (player.isLeft) {
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.am, CONSTANTS.tacticSides.l));
            }

            if (player.isRight) {
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.am, CONSTANTS.tacticSides.r));
            }

            if (player.isCenter) {
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.am, CONSTANTS.tacticSides.rc));
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.am, CONSTANTS.tacticSides.c));
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.am, CONSTANTS.tacticSides.lc));
            }
        }

        if (player.isFW) {
            if (player.isLeft) {
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.fw, CONSTANTS.tacticSides.l));
            }

            if (player.isRight) {
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.fw, CONSTANTS.tacticSides.r));
            }

            if (player.isCenter) {
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.fw, CONSTANTS.tacticSides.rc));
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.fw, CONSTANTS.tacticSides.c));
                result.push(this.buildSidePosition(CONSTANTS.tacticPositions.fw, CONSTANTS.tacticSides.lc));
            }
        }

        return result;
    }

    private getSidePositionFine(pos1: SidePosition, pos2: SidePosition): number {
        return Math.abs(pos1.position - pos2.position) * 10 + Math.abs(pos1.side - pos2.side)*15;
    }

    private buildSidePosition(pos: number, side: number): SidePosition {
        let result = new SidePosition();
        result.position = pos;
        result.side = side;

        return result;
    }
}
